// extracted by mini-css-extract-plugin
export default {"Container":"PageHeader_Container__Jx1UH","Header":"PageHeader_Header__HbqNy"};